export default __webpack_public_path__ + "static/media/Bella 9781846161704.d736ab5c.jpg";